import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* createChargesForNextMounth(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_REQUEST
    })

    let requestPayload: any = {};

    if (action.payload?.contractId) {
      requestPayload.contractId = action.payload?.contractId;
    }
    
    const res = yield call(Http.post, `contracts/create-charges-nextmounth`, {...requestPayload});

    yield put({
      type: Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_SUCCESS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchCreateChargesForNextMounth() {
  yield takeEvery(Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_START, createChargesForNextMounth);
}
